// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

//require("turbolinks").start()

// require('@rails/activestorage').start();
// require('channels');

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import 'polyfills';

import ReactOnRails from 'react-on-rails';

import ShingleWidgetIndex from "../components/Widgets/Roofing/ShingleWidgetCore/Index";
import ShingleWidgetTest from "../components/Widgets/Roofing/ShingleWidgetCore/Test";
import TprsWidgetIndex from "../components/Widgets/Roofing/TprsWidgetCore/Index";
import RoofGawkingIndex from "../components/Widgets/Roofing/RoofGawkingWidget/Index";
import RoofSmarterIndex from "../components/Widgets/Roofing/RoofSmarterWidget/Index";
import DesignAndInspireWidgetIndex from "../components/Widgets/Roofing/DesignAndInspireWidgetCore/Index";
import WarrantyWidgetIndex from "../components/Widgets/Roofing/WarrantyWidget/index";
import QuotingWidgetIndex from '../components/Roofing/QuotingWidget/Index';
import QuotingWidgetForm from '../components/Roofing/QuotingWidget/QuotingWidgetForm';
import QuotingWidgetConfigurator from '../components/Roofing/QuotingWidget/Configurator';
import HomeownerInfo from '../components/Roofing/QuotingWidget/HomeownerInfo';
import FeatureFlagAlert from "../components/FeatureFlag/FeatureFlagAlert";
import Switcher from "../components/location/Switcher";
import CrossingLocale from "../components/CrossingLocale/CrossingLocale";

// This is how react_on_rails can see the react_component('ComponentName') in the browser.
// Use :: in place of / and capitalize folder/component names
ReactOnRails.register({
  'Widgets::Roofing::Shinglewidgetcore::Index': ShingleWidgetIndex,
  'Widgets::Roofing::Shinglewidgetcore::Test': ShingleWidgetTest,
  'Widgets::Roofing::Tprswidgetcore::Index': TprsWidgetIndex,
  'Widgets::Roofing::RoofGawkingWidget::Index': RoofGawkingIndex,
  'Widgets::Roofing::RoofSmarterWidget::Index': RoofSmarterIndex,
  // the design and inspire widget is using its own pack now. but I don't want to break anything so I'm leaving this here for now
  'Widgets::Roofing::Designandinspirewidgetcore::Index': DesignAndInspireWidgetIndex,
  'Widgets::Roofing::Warrantywidget::Index': WarrantyWidgetIndex,
  'Roofing::Quotingwidget::Index': QuotingWidgetIndex,
  'Roofing::Quotingwidget::Quotingwidgetform': QuotingWidgetForm,
  'Roofing::Quotingwidget::Customize': QuotingWidgetConfigurator,
  'Roofing::Quotingwidget::Homeownerinfo': HomeownerInfo,
  'FeatureFlag::Featureflagalert': FeatureFlagAlert,
  'Location::Switcher': Switcher,
  'CrossingLocale::Crossinglocale': CrossingLocale
});
